import { render } from "./SelectWithLabelIcon.vue?vue&type=template&id=d28c129e"
import script from "./SelectWithLabelIcon.vue?vue&type=script&lang=js"
export * from "./SelectWithLabelIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__